<template>
    <div
        style="height: 100vh;
      overflow-y: scroll;
      background-size: cover; padding-bottom: 15rem; background-attachment: fixed; background: #202020;"
        class="px-3 pt-3"
    >
        <div
            style="height: 130vh;"
            v-if="nextLevel"
        >
            <div
                class="profile-container col-12 card"
                style="background: #161616;
    border-radius: 7px;
    border: 1.5px solid #FBE78E !important; box-shadow: none;"
            >
                <div class="up-cont d-flex py-3 pr-3">
                    <div>
                        <img
                            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/app_Icon__03-removebg-preview.png"
                            style="width: 92px; height: 92px; border-radius: 50%;"
                            alt=""
                        >
                    </div>
                    <div class="col-7 pl-4 pt-4">
                        <h3 class="text-white">{{ $store.state.authUser.name }}</h3>
                        <p style="color: #C5B48F">Level {{ $store.state.authUser.level }}</p>
                    </div>
                    <div>
                        <img
                            :src="`https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/levels/vip_${$store.state.authUser.level}.png`"
                            style="width: 60px; height: auto"
                            alt=""
                        >
                    </div>
                </div>
                <div class="down-cont pb-5">
                    <h3
                        style="color: whitesmoke"
                        class="my-4"
                    >{{ $t('level.requirement') }}</h3>
                    <div>
                        <span style="color: #C5B48F">{{ $t('level.current_bet') }} - </span> <span
                            style="color: #C5B48F"
                        >{{ Number($store.state.authUser.total_bet_amount).toLocaleString() }}</span>
                        <div class="my-3">
                            <van-progress
                                v-if="$store.state.authUser.total_bet_amount < nextLevel.target_bet"
                                :pivot-text="`${(($store.state.authUser.total_bet_amount * 100) / nextLevel.target_bet).toFixed(2)}%`"
                                color="#C5B48F"
                                :percentage="($store.state.authUser.total_bet_amount * 100) / nextLevel.target_bet"
                            />
                            <van-progress
                                v-if="$store.state.authUser.total_bet_amount >= nextLevel.target_bet"
                                pivot-text="100%"
                                color="#C5B48F"
                                percentage="100"
                            />
                        </div>
                        <span style="color: #C5B48F">{{ $t('level.required_bet') }} - </span> <span
                            style="color: #C5B48F"
                            v-if="$store.state.authUser.total_bet_amount < nextLevel.target_bet"
                        >{{ Number(nextLevel.target_bet -
                            $store.state.authUser.total_bet_amount).toLocaleString() }}</span> <span
                            v-else
                            style="color: #C5B48F"
                        >0</span>

                        <!-- <hr style="border-color: #C5B48F !important; border-bottom: none;"> -->
                        <div class="my-5">

                        </div>

                        <span style="color: #C5B48F">{{ $t('level.current_deposit') }} - </span> <span
                            style="color: #C5B48F"
                        >{{ Number($store.state.authUser.all_deposit).toLocaleString() }}</span>
                        <div class="my-3">
                            <van-progress
                                v-if="$store.state.authUser.all_deposit < nextLevel.target_deposit"
                                :pivot-text="`${(($store.state.authUser.all_deposit * 100) / nextLevel.target_deposit).toFixed(2)}%`"
                                color="#C5B48F"
                                :percentage="($store.state.authUser.all_deposit * 100) / nextLevel.target_deposit"
                            />
                            <van-progress
                                v-if="$store.state.authUser.all_deposit >= nextLevel.target_deposit"
                                pivot-text="100%"
                                color="#C5B48F"
                                percentage="100"
                            />
                        </div>
                        <span style="color: #C5B48F">{{ $t('level.required_deposit') }} - </span> <span
                            style="color: #C5B48F"
                            v-if="$store.state.authUser.all_deposit < nextLevel.target_deposit"
                        >{{ Number(nextLevel.target_deposit -
                            $store.state.authUser.all_deposit).toLocaleString() }}</span> <span
                            v-else
                            style="color: #C5B48F"
                        >0</span>
                    </div>
                </div>
            </div>
            <div class="vip-levels-container d-flex py-3">
                <div
                    class="d-flex"
                    v-for="(level, index) in levels"
                    :key="index"
                >
                    <div
                        class="level"
                        :class="(level.level <= currentLevel && level.is_collected) ? 'done' : (selectedLevel === level.level ? 'active' : '')"
                        @click="(level.level <= currentLevel && level.is_collected) ? '' : updateLevel(level.level)"
                    >
                        <span class="text-nowrap"><i>V{{ level.level }}</i></span>
                    </div>
                    <div class="middleware my-auto"></div>
                </div>
            </div>
            <div
                class="profile-container col-12 card mt-3"
                style="background: #000000; border: 1px solid #24221E; box-shadow: none"
            >
                <div class="up-cont d-flex justify-content-between">
                    <div class="pt-2 pl-2">
                        <span style="font-size: 3rem; color: #FDDA75">VIP{{ objectSelectedLevel.level }}</span>
                    </div>
                    <div>
                        <img
                            :src="`https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/levels/vip_${selectedLevel}.png`"
                            style="width: 60px; height: auto"
                            alt=""
                        >
                    </div>
                </div>
                <div class="down-cont d-flex pb-3">
                    <div class="col-4 pl-4 pt-4">
                        <h2 class="text-white text-nowrap">{{ Number(objectSelectedLevel.target_bet).toLocaleString() }}
                        </h2>
                        <p
                            style="color: #C5B48F"
                            class=" text-nowrap"
                        >{{ $t('level.bet_amount') }}</p>
                    </div>
                    <div class="col-4 pl-4 pt-4">
                        <h2 class="text-white text-nowrap">{{
                            Number(objectSelectedLevel.target_deposit).toLocaleString() }}</h2>
                        <p
                            style="color: #C5B48F"
                            class=" text-nowrap"
                        >{{ $t('level.deposit_amount') }}</p>
                    </div>
                    <div class="col-4 pl-4 pt-4">
                        <h2 class="text-white text-nowrap">{{ Number(objectSelectedLevel.bonus).toLocaleString() }}</h2>
                        <p
                            style="color: #C5B48F"
                            class="text-nowrap"
                        >{{ $t('level.bonus_amount') }}</p>
                    </div>
                </div>
                <div
                    class="reward mx-auto"
                    v-if="objectSelectedLevel.is_done && !objectSelectedLevel.is_collected"
                >
                    <button
                        class="btn btn-customize"
                        @click="isLoading ? '' : claimReward(objectSelectedLevel.level)"
                    >
                        <div v-if="!isLoading">
                            {{ $t('level.claim_reward') }}
                        </div>
                        <Loading
                            color="#000000"
                            v-if="isLoading"
                            size="24"
                            class="px-4"
                        />
                    </button>
                </div>

                <h3
                    style="color: whitesmoke"
                    class="my-4"
                >အကျိုးခံစားခွင့်များ မှာ အောက်ပါအတိုင်းဖြစ်ပါတယ်။</h3>
                <div class="pb-3">
                    <span style="color: #ccc">အပတ်စဉ်ဘောနပ် </span> - <span style="color: #C5B48F">{{
                        Number(objectSelectedLevel.weekly_bonus).toLocaleString() }}</span> <br>
                    <small class="text-danger">တစ်ပတ်စာ သွင်းငွေ စုစုပေါင်း &nbsp;&nbsp;&nbsp;<span
                            style="color: #C5B48F"
                        >{{ Number(objectSelectedLevel.weekly_total_deposit).toLocaleString() }}</span> &nbsp;&nbsp;
                        နှင့်အထက် ရှိရမည်။</small> <br> <br>
                    <div class="my-3">

                    </div>
                    <!-- <div class="my-3">
                        <van-progress v-if="$store.state.authUser.all_deposit < nextLevel.target_deposit" :pivot-text="`${(($store.state.authUser.all_deposit * 100) / nextLevel.target_deposit).toFixed(2)}%`" color="#C5B48F" :percentage="($store.state.authUser.all_deposit * 100) / nextLevel.target_deposit" />
                        <van-progress v-if="$store.state.authUser.all_deposit >= nextLevel.target_deposit" pivot-text="100%" color="#C5B48F" percentage="100" />
                    </div> -->
                    <p style="color: #ccc">နေ့စဉ်အရှုံးပြန်အမ်းငွေ </p>
                    <span style="color: #C5B48F">Slot - {{ objectSelectedLevel.loss_return_percent }} %</span><span
                        style="color: #ccc"
                        class="mx-2"
                    >/</span>
                    <span style="color: #C5B48F">Fishing - {{ objectSelectedLevel.loss_return_percent }} %</span><span
                        style="color: #ccc"
                        class="mx-2"
                    >/</span>
                    <span style="color: #C5B48F">Arcade - {{ objectSelectedLevel.loss_return_percent }} %</span><span
                        style="color: #ccc"
                        class="mx-2"
                    >/</span>
                    <span style="color: #C5B48F">Card - {{ objectSelectedLevel.loss_return_percent }} %</span> <br>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
    components: {
        Loading
    },
    data() {
        return {
            objectSelectedLevel: {},
            currentLevel: 0,
            selectedLevel: 1,
            levels: [],
            isLoading: false
        }
    },
    computed: {
        nextLevel() {
            return this.levels.find(l => l.level === (this.$store.state.authUser.level + 1));
        }
    },
    methods: {
        ...mapActions(['fetchUser']),
        async claimReward(level) {
            try {
                this.isLoading = true;
                const res = await axios.post('/user/claim-reward', { level }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                });
                Toast.success("Success");
                await this.getLevels();
                await this.fetchUser();
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                Toast.fail("Failed");
            }
        },
        updateLevel(level) {
            this.objectSelectedLevel = this.levels.find(l => l.level === level);
            this.selectedLevel = level;
        },
        async getLevels() {
            // get levels from api
            const res = await axios.get('/user/levels', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });
            this.levels = res.data.data;
            this.objectSelectedLevel = this.levels.find(l => l.level === this.$store.state.authUser.level + 1);
            this.selectedLevel = this.$store.state.authUser.level + 1;
        }
    },
    async mounted() {
        this.$store.commit('setLoading', true);
        await this.getLevels();
        this.currentLevel = this.$store.state.authUser.level
        this.$store.commit('setLoading', false);

        const authUser = await this.fetchUser();
        if (!authUser) {
            this.$router.push('/auth/login');
        }
        // if(authUser && !authUser.is_verified) {
        //     this.$router.push('/auth/verify');
        // }




    }
}
</script>
<style scoped>
.vip-levels-container {
    overflow-y: scroll !important;
}

.btn-customize {
    background: #fedf78;
    color: #360000 !important;
    border-radius: 5px;
    font-size: 1.1rem;
    width: 150px;
}

.level {
    background: #000;
    /* padding: 1rem; */
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-radius: 50%;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    /* border: 2px solid #840303; */
    color: white;
    font-size: 1.2rem;
    box-shadow: none;
    border: 2px solid #21201D;
}

.level.active {

    background: linear-gradient(to bottom, #ffc500 0%, #ff4500 50%, #c71600 100%) !important;
    ;
    /* color: black; */
    /* border: 2px solid transparent; */
    /* border: none; */
}

.level.done {
    background: red;
    color: transparent;
    background-image: url('/public/build/assets/img/icons/common/checked.png');
    background-size: cover;
    border: none;
}

.middleware {
    border: 1px solid #C5B48F;
    /* width: 2rem !important; */
    padding-left: 1rem;
    padding-right: 1rem;
    height: 0px;
}
</style>